var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentPlanet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 187,
    viewBox: "0 0 182 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.78 66.2464C258.784 118.455 240.285 185.486 185.461 215.963C130.637 246.441 60.2496 228.824 28.2456 176.615C-3.75844 124.406 14.7406 57.3758 69.5643 26.8983C124.388 -3.57918 194.776 14.0375 226.78 66.2464Z",
    fill: "url(#paint0_linear_517:3664)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1765 94.6892C83.101 102.721 80.2559 113.034 71.8219 117.723C63.3879 122.413 52.5588 119.703 47.6343 111.672C42.7099 103.64 45.555 93.3272 53.989 88.6377C62.423 83.9482 73.2521 86.6575 78.1765 94.6892Z",
    fill: "url(#paint1_linear_517:3664)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.349 17.0074C111.801 18.849 108.123 21.2439 103.132 22.3566C98.1421 23.4693 93.7295 22.8784 93.2767 21.0368C92.8239 19.1952 96.5024 16.8003 101.493 15.6876C106.483 14.5749 110.896 15.1659 111.349 17.0074Z",
    fill: "url(#paint2_linear_517:3664)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.678 179.51C178.621 191.402 169.806 204.654 154.99 209.108C140.174 213.562 124.968 207.533 121.025 195.641C117.083 183.749 125.897 170.498 140.713 166.043C155.529 161.589 170.736 167.618 174.678 179.51Z",
    fill: "url(#paint3_linear_517:3664)",
    fillOpacity: 0.66
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_517:3664",
    x1: 69.5645,
    y1: 26.8985,
    x2: 177.217,
    y2: 220.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_517:3664",
    x1: 53.989,
    y1: 88.6376,
    x2: 70.5534,
    y2: 118.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_517:3664",
    x1: 101.493,
    y1: 15.6874,
    x2: 102.987,
    y2: 22.3889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035FAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_517:3664",
    x1: 140.713,
    y1: 166.043,
    x2: 153.771,
    y2: 209.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#150305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#113D6E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentPlanet);
export default __webpack_public_path__ + "static/media/payment-planet.d5e8fba0e55cb108cf5492a72c177945.svg";
export { ForwardRef as ReactComponent };